import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import * as lightspeedActions from './lightspeedActions';
import BreadCrumb from '../../components/BreadCrumb/BreadCrumb';
import { Button } from 'merchant-portal-components';
import { Box } from '@material-ui/core';
import { LoadingBlueLarge } from 'merchant-portal-components';

const LightspeedRedirect = ({
  getLightspeedLink,
  requestLightspeedToken,
  isLightspeedConnected,
  isRequesting,
}) => {
  const [errorMsg, setErrorMsg] = useState('');
  useEffect(() => {
    track.page('app-settings-tags');
    const params = new URLSearchParams(window.location.search);
    const code = params.get('code');
    const error = params.get('error');
    if (code) {
      requestLightspeedToken(code);
    } else if (error) {
      setErrorMsg(
        "Authorization wasn't successful, check the issue with lightspeed"
      );
    }
    return () => {};
  }, []);

  const handleLinkLightspeed = async () => {
    console.log('handleLinkLightspeed');
    getLightspeedLink();
  };

  return (
    <div>
      <div style={{ display: 'grid', gridTemplateColumns: '2fr 1fr' }}>
        <BreadCrumb pageName='Link Lightspeed Account' />
      </div>

      <div
        style={{
          backgroundColor: '#fff',
          padding: '20px',
          marginTop: '20px',
          borderRadius: '15px',
          minHeight: '400px',
        }}
      >
        {isRequesting ? (
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
            }}
          >
            <LoadingBlueLarge />
          </Box>
        ) : (
          <Button variant='primary' onClick={handleLinkLightspeed}>
            {isLightspeedConnected
              ? 'Re-Connect to Lightspeed Account'
              : 'Connect to Lightspeed Account'}
          </Button>
        )}
        {errorMsg && (
          <div style={{ color: 'red', marginTop: '20px', fontWeight: 'bold' }}>
            {errorMsg}
          </div>
        )}
      </div>
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    isLightspeedConnected: state.lightspeedReducer.isLightspeedConnected,
    isRequesting: state.lightspeedReducer.isRequesting,
  };
};

export default connect(mapStateToProps, lightspeedActions)(LightspeedRedirect);
